import React from "react";
import BreadCrumb from "@/src/components/Shared/BreadCrumbs";

import server from "@/src/api/server";
import { Col, Row } from "react-bootstrap";
import Image from "next/image";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "@/styles/about.module.scss";
import { handleImage } from "@/src/components/handlers";
import Seo from "@/src/components/Shared/Next-seo";
import { checkRedirect } from "@/src/components/helpers/functions";

const SystemsPage = ({ aboutData, seoData }) => {
  const { locale, formatMessage } = useIntl();

  aboutData?.items?.sort((a) => (a?.slug == "brief" ? -1 : 1));

  const renderFeatures = aboutData?.features?.map((f, k) => (
    <Col
      {...{ xs: "12", md: "8", lg: "6", xl: "4" }}
      className="text-center"
      key={"about" + k}
    >
      <div className="feature">
        <div className="img-wrap-div">
          <div className="img-wrap">
            <Image
              src={handleImage(f?.image)}
              width="45"
              height="47"
              alt="feature"
            />
          </div>
        </div>
        <div className="title">
          <span className="unique-bold">{f?.title?.[locale]}</span>
        </div>
        <div
          className="p"
          dangerouslySetInnerHTML={{
            __html: f?.description?.[locale],
          }}
        ></div>
      </div>
    </Col>
  ));

  return (
    <>
      {seoData?.title?.[locale] && (
        <Seo
          title={seoData?.title?.[locale]}
          description={seoData?.description?.[locale]}
          keywords={seoData?.keywords?.[locale]}
        />
      )}
      <BreadCrumb
        heading={formatMessage({ id: "about" })}
        description={`${formatMessage({
          id: "main",
        })} / ${formatMessage({
          id: "about",
        })}`}
        background={aboutData?.breadCurmbImage}
      />
      <div className={`wrapper ${styles.aboutPage}`}>
        {aboutData?.items?.map((item, index) => (
          <Row key={index} className="details-row w-100 mb-5">
            <div
              className="w-auto "
              style={{
                ...(index % 2
                  ? { order: "-1", marginInline: "0 auto" }
                  : { order: "1", marginInline: "auto 0 " }),
              }}
            >
              <Image
                src={handleImage(item?.image)}
                width="494"
                height="500"
                alt="about-image"
              />
            </div>
            <Col xl="6" md="12" className="align-self-center ">
              {index == 0 && (
                <span className="section-tag text-start">
                  <FormattedMessage id="about" />
                </span>
              )}
              <h2 className="unique-bold d-inline-flex align-items-center">
                {item?.heading?.[locale]}
              </h2>
              <div
                className="text-start dangerous-html"
                dangerouslySetInnerHTML={{
                  __html: item?.description?.[locale],
                }}
              ></div>
            </Col>
          </Row>
        ))}
        <div className="row features">{renderFeatures}</div>
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  const [homeResponse, aboutResponse, seoPageResponse] = await Promise.all([
    server.get("/pages/home"),
    server.get("/pages/about"),
    server.get("/pages/seo-data"),
  ]);

  const sectionData = (r) => r?.data?.data?.page?.sections || [];

  const seoData = sectionData(seoPageResponse)?.find(
    (section) => section?.pageName === "about-us",
  );

  const getData = (section, response) =>
    sectionData(response)?.filter((e) => e?.slug == section)?.[0] || [];

  const getPageSection = (slug) =>
    sectionData(aboutResponse)?.filter((e) => e?.slug == slug)?.[0]?.[slug] ||
    [];
  const homeData = (section) =>
    sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];

  return {
    props: {
      aboutData: {
        ...getData("about", aboutResponse),
        items:
          aboutResponse?.data?.data?.page?.sections?.filter(
            (item) => item?.features == undefined,
          ) || [],
        features: getPageSection("features"),
        statistics: getPageSection("statistics"),
        breadCurmbImage: homeData("intro")?.items[0]?.backgroundImage,
      },
      seoData,
    },
  };
}

export default SystemsPage;
